import { useContext } from 'react';
import EntityTypeContext from '../EntityTypeContext';

export default function useTypes()
{
    const entityTypeStore = useContext(EntityTypeContext);

    return entityTypeStore.bespoke.types;
}
